<template>
  <div class="logo">
    <!--    <router-link :to="{path:'/'}">-->
    <!--    </router-link>-->
    <img src="@/assets/logo-hangyang.png" width="64px" height="40px"/>
    <h1 v-if="showTitle">
      {{ title }}
    </h1>
  </div>
</template>

<script>
// import LogoPng from '@/assets/min-logo.png'

export default {
  name: 'Logo',
  components: {
    // LogoPng
  },
  props: {
    title: {
      type: String,
      default: '杭氧设备资产数字化管理平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.logo{
  img{
    width: 64px !important;
    height: 40px !important;
    margin-right: 8px;
  }
  h1{
    // height: 40px;
    // line-height: 40px;
    margin: 0 !important;
    //width: 450px !important;
    font-size: 18px !important;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #08409F !important;
  }
}
</style>
